import { UpdateGenerationConfiguration } from "./UpdateGenerationConfiguration";
import { DeleteCustomSourceCountryConfiguration } from "./DeleteCustomSourceCountryConfiguration";
import { UpdateCustomSourceConfiguration } from "./UpdateCustomSourceConfiguration";
export class UpdateGenerationConfigurationFactory {
  static create($type) {
    if ($type === "V1.GenerationConfiguration.UpdateGenerationConfiguration") {
      const result = new UpdateGenerationConfiguration();
      return result;
    }
    if ($type === "V1.GenerationConfiguration.DeleteCustomSourceCountryConfiguration") {
      const result = new DeleteCustomSourceCountryConfiguration();
      return result;
    }
    if ($type === "V1.GenerationConfiguration.UpdateCustomSourceConfiguration") {
      const result = new UpdateCustomSourceConfiguration();
      return result;
    }
    throw new Error($type + " not found");
  }
}
